export default require('./time-picker');



/** WEBPACK FOOTER **
 ** ../src/time-picker/index.js
 **/